import React, { useState } from 'react';
import ModalVideo from 'react-modal-video';
import 'react-modal-video/scss/modal-video.scss';
import factsBg from '../../assets/images/facts-bg.png';
import counterIcon1 from '../../assets/images/icons/facts-icon1.png';
import counterIcon2 from '../../assets/images/icons/facts-icon2.png';
import FactsCounter from './FactsCounter';

function Facts() {
  const [isOpen, setOpen] = useState(false);

  return (
    <>
      <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId="EZ9DrY43wtw"
        onClose={() => setOpen(false)}
      />

      <section
        className="facts-wrapper section-padding bg-cover"
        style={{ backgroundImage: `url(${factsBg})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="left-content">
                <div className="section-head">
                  <span className="heading-bg">Facts</span>
                  <h2 className="section-title">
                    Construction &amp; engineering real solutions
                    <span className="heading-dot" />
                  </h2>
                  <p className="body-text">
                    Building a house is not a problem for our employees; it is
                    also possible to develop interior design and control
                    electronic systems. For an initial consultation, you can
                    call the phones that are posted on the site, you can also
                    fill out a special form in which you ask your questions.
                  </p>
                </div>

                <div className="facts-counter d-flex">
                  <FactsCounter
                    icon={counterIcon1}
                    number={1500}
                    text="Projects Completed"
                  />
                  <FactsCounter
                    icon={counterIcon2}
                    number={3200}
                    text="Work Completed"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 d-flex align-items-center justify-content-center">
              <div className="right-content">
                <button
                  type="button"
                  className="button play-button "
                  onClick={() => setOpen(true)}
                >
                  Play
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Facts;
